export { NewUserFollowTags as Tags } from './NewUserFollowTags';
